import { FormControlLabel, Switch } from '@mui/material';
import type { SettingsPanelProps } from '../card';

export const TextFieldSettingsPanel = ({ settings, onChange }: SettingsPanelProps<{ multiline?: boolean }>) => {
  return (
    <FormControlLabel
      label="Multiple lines"
      control={
        <Switch
          sx={{ ml: 2 }}
          checked={settings.multiline === true}
          onChange={event => onChange({ multiline: event.target.checked })}
        />
      }
    />
  );
};
